import { render, staticRenderFns } from "./BidderEditTabGeneralInformation.vue?vue&type=template&id=07efed48&"
import script from "./BidderEditTabGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./BidderEditTabGeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./BidderEditTabGeneralInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports